import MainInfo from './mainInfo'
export default MainInfo
